// collection banner js
class CollectionBanner extends HTMLElement {
  connectedCallback() {
    this.card = this.querySelector('.js-collection-banner__card');
    const togglePopup = (e, open) => {
      e?.preventDefault();
      this.card?.classList.toggle('is-popup-open', open);
    };

    if (this.querySelector('.js-collection-banner__inner-popup')) {
      const openTriggers = this.querySelectorAll('.js-collection-banner__overlay-link, .js-collection-banner__btn, .js-collection-banner__open-popup');
      openTriggers.forEach(trigger => {
        if (trigger.tagName === 'A' && trigger.getAttribute('href') && trigger.getAttribute('href') !== '#') {
          return;
        }
        trigger.addEventListener('click', e => togglePopup(e, true));
      });
      this.querySelector('.js-collection-banner__inner-popup-close')?.addEventListener('click', e => togglePopup(e, false));
    }

    const slider = this.querySelector('.slider');
    if (!slider) return;

    let isDown = false, startX, scrollLeft, isDragging = false;
    slider.style.cursor = 'grab';

    slider.addEventListener('mousedown', e => { isDown = true; isDragging = false; startX = e.pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft; });
    slider.addEventListener('mouseleave', () => { isDown = false; slider.classList.remove('is-dragging'); });
    slider.addEventListener('mouseup', () => { isDown = false; slider.classList.remove('is-dragging'); setTimeout(() => isDragging = false, 0); });
    slider.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const walk = (e.pageX - slider.offsetLeft - startX) * 2;
      if (Math.abs(walk) > 5 && !isDragging) { isDragging = true; slider.classList.add('is-dragging'); }
      slider.scrollLeft = scrollLeft - walk;
    });
    slider.addEventListener('click', e => isDragging && (e.preventDefault(), e.stopPropagation()), true);
  }
}

if (!customElements.get('collection-banner')) {
  customElements.define('collection-banner', CollectionBanner);
}

window.adjustBannerHeights = () => {
  const banners = document.querySelectorAll('.collection-banner-item--2x2');
  if (!banners.length) return;

  const cardInfoDefault = document.querySelector('.card_product_info');
  const grid = document.getElementById('product-grid');
  const cols = grid ? grid.getAttribute('data-desktop-columns') : null;
  const is4Cols = !cols || cols === '4';

  if (window.innerWidth >= 1000 && is4Cols) {
    banners.forEach(banner => {
      // Find the next sibling that is a product card
      let nextCard = banner.nextElementSibling;
      while (nextCard && !nextCard.querySelector('.card_product_info')) {
        nextCard = nextCard.nextElementSibling;
      }

      let cardInfo = null;
      if (nextCard) {
        cardInfo = nextCard.querySelector('.card_product_info');
      }

      // Fallback to default card info if next card is not found
      if (!cardInfo) {
        cardInfo = cardInfoDefault;
      }

      if (cardInfo) {
        const height = cardInfo.offsetHeight;
        banner.style.height = `calc(100% - ${height}px)`;
      }
    });
  } else {
    banners.forEach(banner => {
      banner.style.height = '';
    });
  }
};


window.initializeBanners = () => {
  const grid = document.getElementById('product-grid');
  const banners = Array.from(document.querySelectorAll('.js-dynamic-banner'));
  if (!grid || !banners.length) return;

  const mobile = window.matchMedia('(min-width: 750px)');
  
  const hasFilterParams = window.location.search.includes('filter.');

  const placeBanners = () => {
    if (hasFilterParams) {
      banners.forEach(banner => { banner.style.display = 'none'; });
      return;
    }

    banners.forEach(banner => { banner.remove(); banner.style.display = ''; });
    
    banners.map(banner => ({
      el: banner, 
      pos: parseInt(banner.dataset[mobile.matches ? 'posDesktop' : 'posMobile']) || 1 
    }))
    .sort((pos_desktop, pos_mobile) => pos_desktop.pos - pos_mobile.pos)
    .forEach(({ el, pos }) => {
      grid.insertBefore(el, grid.children[Math.max(0, pos - 1)]);
    });

    if (typeof window.adjustBannerHeights === 'function') {
      window.adjustBannerHeights();
    }
  };

  if (window._bannerMatchMediaListener) {
    mobile.removeEventListener('change', window._bannerMatchMediaListener);
  }
  window._bannerMatchMediaListener = placeBanners;
  mobile.addEventListener('change', window._bannerMatchMediaListener);
  
  placeBanners();
};

document.addEventListener('DOMContentLoaded', () => {
  window.initializeBanners();
  if (typeof window.adjustBannerHeights === 'function') {
    window.adjustBannerHeights();
  }
});

window.addEventListener('load', () => {
  if (typeof window.adjustBannerHeights === 'function') {
    window.adjustBannerHeights();
  }
});

window.addEventListener('resize', () => {
  if (typeof window.adjustBannerHeights === 'function') {
    window.adjustBannerHeights();
  }
});


// flickty slider js 
if (!customElements.get('flickity-product-slider')) {
  class FlickityProductSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderInitAttempts = 0;
    }

    connectedCallback() {
      this.initFlickity();
    }

    initFlickity() {
      if (typeof Flickity !== 'undefined') {
        this.flickity = new Flickity(this, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
          draggable: true,
          imagesLoaded: true, 
          dragThreshold: 10
        });

        // Custom SVG arrows (dual stroke for contrast on product imagery)
        const cardSliderArrowLeft = `<svg class="flickity-button-icon" width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.38892 0.194336L0.388916 5.19434L5.38892 10.1943" stroke="#1E1E1E" stroke-width="0.55"/><path d="M6.38892 0.194336L1.38892 5.19434L6.38892 10.1943" stroke="white" stroke-width="0.55"/></svg>`;
        const cardSliderArrowRight = `<svg class="flickity-button-icon" width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.19446 10.1943L6.19446 5.19434L1.19446 0.194336" stroke="#1E1E1E" stroke-width="0.55"/><path d="M0.194456 10.1943L5.19446 5.19434L0.194458 0.194336" stroke="white" stroke-width="0.55"/></svg>`;
        const prevButton = this.querySelector('.flickity-prev-next-button.previous');
        if (prevButton) {
          prevButton.innerHTML = cardSliderArrowLeft;
        }

        const nextButton = this.querySelector('.flickity-prev-next-button.next');
        if (nextButton) {
          nextButton.innerHTML = cardSliderArrowRight;
        }

        if (this.dataset.productUrl) {
            this.style.cursor = 'pointer';
        }
        
        this.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
            if (event.target.closest('.flickity-prev-next-button')) {
                return;
            }
            if (event.target.closest('.card__media-link')) {
                return;
            }
            const productUrl = this.dataset.productUrl;
            if (productUrl) {
                window.location.href = productUrl;
            }
        });

        const stopArrowEvent = (e) => {
          if (!e.target.closest('.flickity-prev-next-button')) return;
          e.preventDefault();
          e.stopPropagation();
        };
        this.addEventListener('click', stopArrowEvent);
        this.addEventListener('mousedown', stopArrowEvent);

        // Fix for Flickity initialized in hidden containers (like predictive search modal)
        this.resizeObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.flickity) {
              this.flickity.resize();
            }
          });
        });
        this.resizeObserver.observe(this);

      } else {
        if (!window.flickityLoading) {
          window.flickityLoading = true;
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/flickity@2/dist/flickity.min.css';
          document.head.appendChild(link);
          
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
          script.onload = () => {
             window.flickityLoaded = true;
          };
          document.head.appendChild(script);
        }

        if (this.sliderInitAttempts < 50) {
          this.sliderInitAttempts++;
          setTimeout(() => this.initFlickity(), 100);
        }
      }
    }

    disconnectedCallback() {
      if (this.flickity) {
        this.flickity.destroy();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  customElements.define('flickity-product-slider', FlickityProductSlider);
}

// cart size selector — cart line swap + wishlist add-to-cart
class CartSizeSelector extends HTMLElement {
  connectedCallback() {
    if (this._initialized) {
      return;
    }

    this._initialized = true;
    this._isDrawerLine = Boolean(this.closest('#cart-products'));
    this.mode = this.dataset.mode || 'swap';
    this.toggle = this.querySelector('.js-cart-size-selector__toggle');
    this.dropdown = this.querySelector('.js-cart-size-selector__dropdown');
    this.overlay = this.querySelector('.js-cart-size-selector__overlay');
    this.closeBtn = this.querySelector('.js-cart-size-selector__close');

    this._suppressCloseUntil = 0;
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onSizeButtonClick = this.onSizeButtonClick.bind(this);
    this.updateDropdownMargin = this.updateDropdownMargin.bind(this);

    if (this.toggle) {
      this.toggle.addEventListener('click', this.onToggleClick);
      this.toggle.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.onToggleClick(event);
        }
      });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.onCloseClick);
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.onOverlayClick);
    }

    this.addEventListener('click', (event) => {
      const sizeButton = event.target.closest('.js-cart-size-selector__button');

      if (!sizeButton || !this.contains(sizeButton)) {
        return;
      }

      this.onSizeButtonClick({ ...event, currentTarget: sizeButton });
    });

    this.onDropdownClick = this.onDropdownClick.bind(this);
    this.dropdown?.addEventListener('click', this.onDropdownClick);

    document.addEventListener('click', this.onDocumentClick);
    window.addEventListener('resize', this.updateDropdownMargin);
    setTimeout(() => this.updateDropdownMargin(), 0);
  }

  disconnectedCallback() {
    if (this.toggle) {
      this.toggle.removeEventListener('click', this.onToggleClick);
    }
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.onCloseClick);
    }
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.onOverlayClick);
    }
    document.removeEventListener('click', this.onDocumentClick);
    window.removeEventListener('resize', this.updateDropdownMargin);
    this.dropdown?.removeEventListener('click', this.onDropdownClick);
    this._restoreDrawerMobileSheet();
    this._initialized = false;
  }

  isDrawerMobileSheet() {
    const inDrawer = this._isDrawerLine || Boolean(this.closest('#cart-products'));
    return inDrawer && window.matchMedia('(max-width: 768px)').matches;
  }

  shouldSuppressClose() {
    return Date.now() < this._suppressCloseUntil;
  }

  onDropdownClick(event) {
    const sizeButton = event.target.closest('.js-cart-size-selector__button');

    if (!sizeButton || this.contains(sizeButton) || !this.dropdown?.contains(sizeButton)) {
      return;
    }

    this.onSizeButtonClick({ ...event, currentTarget: sizeButton });
  }

  _mountDrawerMobileSheet() {
    if (!this.isDrawerMobileSheet() || !this.dropdown) {
      return;
    }

    if (!this._drawerSheetPortalized) {
      this._drawerSheetPortalized = true;
      this._portalOverlayParent = this.overlay?.parentNode || null;
      this._portalDropdownParent = this.dropdown.parentNode || null;
      this._portalOverlayNext = this.overlay?.nextSibling || null;
      this._portalDropdownNext = this.dropdown.nextSibling || null;
    }

    if (this.overlay && this.overlay.parentNode !== document.body) {
      this.overlay.classList.add('cart-size-selector__overlay--drawer-portal');
      document.body.appendChild(this.overlay);
    }

    if (this.dropdown.parentNode !== document.body) {
      this.dropdown.classList.add('cart-size-selector__dropdown--drawer-portal');
      document.body.appendChild(this.dropdown);
    }
  }

  _restoreDrawerMobileSheet() {
    if (!this._drawerSheetPortalized) {
      return;
    }

    const restoreNode = (node, parent, nextSibling, portalClass) => {
      if (!node || node.parentNode !== document.body) {
        return;
      }

      node.classList.remove(portalClass);

      if (parent && document.body.contains(parent)) {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(node, nextSibling);
        } else {
          parent.appendChild(node);
        }
      }
    };

    restoreNode(
      this.overlay,
      this._portalOverlayParent,
      this._portalOverlayNext,
      'cart-size-selector__overlay--drawer-portal'
    );
    restoreNode(
      this.dropdown,
      this._portalDropdownParent,
      this._portalDropdownNext,
      'cart-size-selector__dropdown--drawer-portal'
    );

    this._drawerSheetPortalized = false;
    this._portalOverlayParent = null;
    this._portalDropdownParent = null;
    this._portalOverlayNext = null;
    this._portalDropdownNext = null;
  }

  closeOtherDrawerSizeSelectors() {
    const root = this.closest('#cart-products');
    if (!root) {
      return;
    }

    root.querySelectorAll('cart-size-selector').forEach((entry) => {
      if (entry !== this && typeof entry.close === 'function') {
        entry.close();
      }
    });
  }

  isOpen() {
    return Boolean(this.dropdown && this.dropdown.hidden === false);
  }

  open() {
    this.closeOtherDrawerSizeSelectors();
    this._suppressCloseUntil = Date.now() + 500;

    if (this.toggle) {
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    this.classList.add('cart-size-selector--open');

    if (this.isDrawerMobileSheet()) {
      this._mountDrawerMobileSheet();
    }

    if (this.dropdown) {
      this.dropdown.hidden = false;
      this.dropdown.removeAttribute('hidden');
    }

    if (this.overlay && window.matchMedia('(max-width: 768px)').matches) {
      this.overlay.hidden = false;
      this.overlay.removeAttribute('hidden');
    }

    if (this.mode === 'wishlist-add') {
      this.closest('.swym-wishlist-card')?.classList.add('swym-wishlist-card--size-popup-open');
    }
  }

  close() {
    if (this.toggle) {
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    this.classList.remove('cart-size-selector--open');

    if (this.dropdown) {
      this.dropdown.hidden = true;
      this.dropdown.setAttribute('hidden', '');
    }

    if (this.overlay) {
      this.overlay.hidden = true;
      this.overlay.setAttribute('hidden', '');
    }

    if (this.mode === 'wishlist-add') {
      this.closest('.swym-wishlist-card')?.classList.remove('swym-wishlist-card--size-popup-open');
      this.closest('.swym-wishlist-card')
        ?.querySelector('.js-wishlist-add-to-cart')
        ?.setAttribute('aria-expanded', 'false');
    }

    this._restoreDrawerMobileSheet();
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!this._initialized) {
      return;
    }

    if (this.isOpen()) {
      this.close();
      return;
    }

    this.open();
  }

  onCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.close();
  }

  onOverlayClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.shouldSuppressClose()) {
      return;
    }
    this.close();
  }

  onDocumentClick(event) {
    const target = event.target;

    if (!this.isOpen() || this.shouldSuppressClose()) {
      return;
    }

    if (this.contains(target) || this.dropdown?.contains(target) || this.overlay?.contains(target)) {
      return;
    }

    if (target.closest('.js-wishlist-add-to-cart[aria-expanded="true"]')) {
      return;
    }

    this.close();
  }

  async onSizeButtonClick(event) {
    const button = event.currentTarget;

    if (button.classList.contains('is-active') || button.classList.contains('is-disabled')) {
      return;
    }

    if (this.mode === 'wishlist-add') {
      return;
    }

    this.close();

    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    if (!cartItems) {
      return;
    }

    cartItems.enableLoading(this.dataset.line);

    const newSize = button.innerText.trim();
    const dd = this.toggle?.querySelector('dd');

    if (dd) {
      dd.innerText = newSize;
    }

    const sizeButtons = this.dropdown
      ? this.dropdown.querySelectorAll('.js-cart-size-selector__button')
      : this.querySelectorAll('.js-cart-size-selector__button');
    sizeButtons.forEach((entry) => entry.classList.remove('is-active'));
    button.classList.add('is-active');

    await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: button.dataset.variantId, quantity: this.dataset.quantity }),
    });

    const res = await fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: this.dataset.lineItemKey,
        quantity: 0,
        sections: cartItems.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    const state = await res.json();
    cartItems.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      const target = element.querySelector(section.selector) || element;
      target.innerHTML = new DOMParser()
        .parseFromString(state.sections[section.section], 'text/html')
        .querySelector(section.selector).innerHTML;
    });
    cartItems.disableLoading(this.dataset.line);

    if (typeof window.initCartDrawerSizeSelectors === 'function') {
      window.initCartDrawerSizeSelectors(cartItems);
    }
  }

  updateDropdownMargin() {
    if (this.isOpen() && this._drawerSheetPortalized && !window.matchMedia('(max-width: 768px)').matches) {
      this.close();
      return;
    }

    if (this.mode === 'wishlist-add') {
      return;
    }

    if (this.closest('#cart-products')) {
      if (this.dropdown) {
        this.dropdown.style.marginLeft = '';
      }
      return;
    }

    if (window.innerWidth >= 769 && this.toggle && this.dropdown) {
      this.dropdown.style.marginLeft = `${this.toggle.offsetWidth - 15}px`;
    } else if (this.dropdown) {
      this.dropdown.style.marginLeft = '';
    }
  }
}

if (!customElements.get('cart-size-selector')) {
  customElements.define('cart-size-selector', CartSizeSelector);
}

function removeStaleCartDrawerSizeSheetPortals() {
  document
    .querySelectorAll(
      'body > .cart-size-selector__dropdown, body > .cart-size-selector__overlay'
    )
    .forEach((node) => {
      node.hidden = true;
      node.setAttribute('hidden', '');
      node.classList.remove(
        'cart-size-selector__dropdown--drawer-portal',
        'cart-size-selector__overlay--drawer-portal'
      );
      node.remove();
    });
}

window.initCartDrawerSizeSelectors = function (root) {
  const scope = root || document;
  scope.querySelectorAll('#cart-products cart-size-selector, cart-drawer-items cart-size-selector').forEach((selector) => {
    if (selector._initialized) {
      return;
    }

    if (typeof selector.connectedCallback === 'function') {
      selector.connectedCallback();
    }
  });
};

window.closeCartDrawerSizeSelectors = function (root) {
  const scope = root || document.querySelector('cart-drawer') || document;
  scope
    .querySelectorAll('#cart-products cart-size-selector, cart-drawer-items cart-size-selector')
    .forEach((selector) => {
      if (typeof selector.close === 'function') {
        selector.close();
      }
    });
  removeStaleCartDrawerSizeSheetPortals();
};

// size guide page
 if (!customElements.get('size-guide-tables')) {
    customElements.define('size-guide-tables', class extends HTMLElement {
      constructor() {
        super();
        this.initToggle();
      }

      initToggle() {
        const contentDiv = this.querySelector('.whitepage-content');
        if (!contentDiv) return;

        const headingsInit = contentDiv.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, strong, em, div');
        headingsInit.forEach(heading => {
          if (heading.childNodes.length === 1 && heading.childNodes[0].nodeType === Node.TEXT_NODE) {
            if (heading.textContent.includes('*MEDIDAS EN CM') || heading.textContent.includes('*MEDIDAS EN IN')) {
              heading.innerHTML = heading.textContent.replace(/\*MEDIDAS EN (CM|IN)/g, '<span class="asterisk-top">*</span>MEDIDAS EN $1');
            }
          } else if (heading.textContent.includes('*MEDIDAS EN CM') || heading.textContent.includes('*MEDIDAS EN IN')) {
            if (!heading.innerHTML.includes('asterisk-top')) {
              heading.innerHTML = heading.innerHTML.replace(/\*MEDIDAS EN (CM|IN)/g, '<span class="asterisk-top">*</span>MEDIDAS EN $1');
            }
          }
        });
        
        const tables = contentDiv.querySelectorAll('table');
        
        for (let i = 0; i < tables.length; i += 2) {
          if (i + 1 < tables.length) {
            const tableCM = tables[i];
            const tableIN = tables[i + 1];
            
            // Hide the generic "CM" and "IN" text paragraphs above the tables if they exist
            const hidePrevText = (el, text) => {
              let prev = el.previousElementSibling;
              if (prev && prev.tagName === 'P' && prev.textContent.trim().toUpperCase() === text) {
                prev.style.display = 'none';
              }
            };
            hidePrevText(tableCM, 'CM');
            hidePrevText(tableIN, 'IN');
            
            const toggleDiv = document.createElement('div');
            toggleDiv.className = 'size-guide-toggle';
            toggleDiv.innerHTML = `
              <button class="sg-toggle-btn active" data-target="cm">CM</button>
              <button class="sg-toggle-btn" data-target="in">IN</button>
            `;
            
            tableCM.parentNode.insertBefore(toggleDiv, tableCM);
            tableIN.style.display = 'none';
            
            const btns = toggleDiv.querySelectorAll('.sg-toggle-btn');
            btns.forEach(btn => {
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                btns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                const targetUnit = btn.dataset.target.toUpperCase();
                
                if (btn.dataset.target === 'cm') {
                  tableCM.style.display = '';
                  tableIN.style.display = 'none';
                } else {
                  tableCM.style.display = 'none';
                  tableIN.style.display = '';
                }

                const headings = contentDiv.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, strong, em, div');
                headings.forEach(heading => {
                  if (heading.childNodes.length === 1 && heading.childNodes[0].nodeType === Node.TEXT_NODE) {
                    if (heading.textContent.includes('MEDIDAS EN CM') || heading.textContent.includes('MEDIDAS EN IN')) {
                      heading.textContent = heading.textContent.replace(/MEDIDAS EN (CM|IN)/g, `MEDIDAS EN ${targetUnit}`);
                    }
                  } else if (heading.textContent.includes('MEDIDAS EN CM') || heading.textContent.includes('MEDIDAS EN IN')) {
                     // Safer replacement for elements with innerHTML to avoid destroying children unnecessarily,
                     // but we do it anyway if it matches.
                     heading.innerHTML = heading.innerHTML.replace(/MEDIDAS EN (CM|IN)/g, `MEDIDAS EN ${targetUnit}`);
                  }
                });
              });
            });
          }
        }
      }
    });
  }